
import Approval from "locales/plus/th/approval/approval.json"
import ApprovelList from "locales/plus/th/approval/approvelList.json"

export const ApprovalTH ={
    ...Approval,
    ...ApprovelList
    
}